<div class="wrapper">
  <input type="checkbox" id="cb"/>
  <label for="cb" class="check-box"></label>
  <span class="content"><ng-content></ng-content></span>
</div>
